import { useCallback, useState } from 'react'
import { AggregateField } from '../../../../domain/entity/WbsItemEntity'
import { WorkloadUnit } from '../../../../lib/functions/workload'

export type UseUnitSetting = {
  aggregateField: AggregateField
  workloadUnit: WorkloadUnit
  isUnitSettled: boolean
  selectUnit: (field: AggregateField, unit: WorkloadUnit) => void
  setWorkloadUnit: (unit: WorkloadUnit) => void
}

export const useUnitSetting = (
  savedAggregateField: AggregateField | null,
  workloadUnit: WorkloadUnit,
  setWorkloadUnit: (unit: WorkloadUnit) => void
): UseUnitSetting => {
  const [pendingField, setPendingField] = useState<AggregateField | null>(null)

  const aggregateField =
    pendingField ?? savedAggregateField ?? AggregateField.WBS_ITEM_COUNT
  const isUnitSettled = savedAggregateField !== null || pendingField !== null

  const selectUnit = useCallback(
    (field: AggregateField, unit: WorkloadUnit) => {
      setPendingField(field)
      setWorkloadUnit(unit)
    },
    [setWorkloadUnit]
  )

  return {
    aggregateField,
    workloadUnit,
    isUnitSettled,
    selectUnit,
    setWorkloadUnit,
  }
}
